import { gql } from "lib/apolloClient";
import { unitPlanFragment } from "IBPlanner/modules/IBFragments";

export const getUnitPlanCollaboratorsQuery = gql`
  query getUnitPlanCollaborators(
    $id: ID!
    $collaboratorsFilter: CollaboratorFilters
  ) {
    node(id: $id, type: UNIT_PLAN) {
      id
      ... on UnitPlan {
        ...unitPlanItem
      }
    }
  }
  ${unitPlanFragment.unitPlanCollaborator}
`;
